import { mapGetters } from 'vuex'
import Container from '@/components/Container/Container'
import Map from '@/components/Map/Map'
import Spinner from '@/components/Spinner/Spinner'
import FieldHorizontal from '@/components/FieldHorizontal/FieldHorizontal'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'Demo',
  components: {
    Container,
    FieldHorizontal,
    FontAwesomeIcon,
    Map,
    Spinner
  },
  computed: {
    ...mapGetters({
      isLoading: 'demoLoading',
      error: 'demoError',
      session: 'demoSession',
      vehicle: 'demoVehicle',
      sessionData: 'demoSessionData'
    })
  },
  created() {
    this.$store.dispatch('getDemoSession')
  }
}



// WEBPACK FOOTER //
// ./src/components/Demo/script.js